import { execute, INSERT, SELECT } from "@/utils/database_module";
import { Chat, ChatMessage, Conflict, User } from "@/utils/types";

const chats = {
    getAll : async () => {

        // * get the chats whose last message is the most recent
        const openedChats = await execute(`SELECT * FROM chat_messages cm WHERE  ( cm.user_id , cm.date) IN (SELECT  user_id,  MAX(date) AS max_date FROM  chat_messages GROUP BY  user_id ) GROUP BY  chat_id ORDER BY cm.date DESC`) as ChatMessage[];
        
        const conflicts = await execute(`SELECT conflicts.type ,  conflicts.id as conflict_id, users.id as user_id  FROM conflicts join orders join users on conflicts.order_id= orders.id and users.id = orders.user_id `) as Conflict[]
       
        const users = (await SELECT(`users`, { columns: ["first_name", "last_name", "profile_pic","email", "id", "role", "token"], isIndexed: true, })) as any[];
        
        for (const user of Object.values(users)) {
            user.conflicts = conflicts.filter((c : any)=> c.user_id == user.id)     
        }   
        for (const chat of openedChats) {
            chat.user = users[chat.user_id];
            if(!users[chat.user_id])
                chat.user={first_name : "unknown", id :chat.user_id}
        }

        return { openedChats : openedChats , allChats : Object.values(users)}
       
      
    },

    getOne : async (id : number , isUserLoggedIn? : boolean) => {
        const messages = (await SELECT(`chat_messages`, { conditions: [{ column: "chat_id", operator: "=", value: id }], order: "`chat_messages`.`date` DESC", })) as unknown as ChatMessage[];
        if(!isUserLoggedIn) return messages;

        const users = (await SELECT(`users`, { columns: ["first_name", "last_name", "profile_pic", "email", "id", "role", "token"], })) as User[];
        for (const message of messages) {
            message.user = users.find((u)=> u.id == message.sender_id);     
        }
        return messages

    },

    insert : async (data : {chat_id : string , user_id : any , msg : string , sender_id : any , image : string , isConflict : 0 | 1}) => {
        const message = {
            chat_id: data?.chat_id,
            user_id: data?.user_id ??data?.chat_id ,
            message: data?.msg,
            sender_id: data?.sender_id,
            image: data?.image,
            is_conflict: data?.isConflict ,
          };
        return await INSERT("chat_messages", message);
    }
}

export default chats